import axios from "axios";
import vue from "vue";
import helpers from "@/services/helpers";
export default {
    namespaced: true,
    state: {
        shopping: '',
        categorySelects: [],
        order: ''
    },
    getters: {
        shopping: state => state.shopping,
        categorySelects: state => state.categorySelects,
        getOrder: state => state.order
    },
    mutations: {
        setShopping(state, payload) {
            state.shopping = payload.data;
        },
        setAddShopping(state, payload) {
            // state.shopping = payload.data;
        },
        setDeleteShopping(state, payload) {
            if (!payload) {
                state.shopping.products = state.shopping.products.filter(
                    item => item.id !== payload
                );
            } else {
                state.shopping = ''
            }
        },
        setOrder(state, payload) {
            state.order = payload.data
        }
    },
    actions: {
        async get({ commit }) {
            commit("config/SET_OVERLAY", true, { root: true });
            try {
                const res = await axios.get('/api/shopping-cart');
                commit("setShopping", res.data);
                return res.data;
            } catch (error) {
                throw error;
            } finally {
                commit("config/SET_OVERLAY", false, { root: true });
            }
        },
        async createOrUpdate({ commit, dispatch }, payload) {
            commit("config/SET_OVERLAY", true, { root: true });
            try {
                if (payload.type !== 0) {
                    const resp = await axios.post("/api/update-item-in-cart", payload);
                    // commit("SET_UPDATE_CATEGORY", resp.data);
                    return resp.data;
                } else {
                    const res = await axios.post('/api/shopping-cart', payload);
                    return res.data;
                }
            } catch (error) {
                throw error;
            } finally {
                dispatch('get')
                localStorage.removeItem('order')
                commit("setOrder", '');
                commit("config/SET_OVERLAY", false, { root: true });
            }
        },
        async delete({ commit, dispatch }, payload) {
            commit("config/SET_OVERLAY", true, { root: true });
            try {
                if (payload.type === 1) {
                    const res = await axios.delete(`/api/delete-shopping-cart-item/${payload.id}`);
                    // commit("setDeleteShopping", payload.id);
                    return res.data;
                } else {
                    const res = await axios.delete(`/api/shopping-cart/${payload.id}`);
                    // commit("setDeleteShopping", null);
                    return res.data;
                }
            } catch (error) {
                throw error;
            } finally {
                dispatch('get')
                localStorage.removeItem('order')
                commit("setOrder", '');
                commit("config/SET_OVERLAY", false, { root: true });
            }
        },
        async createdOrder({ commit }, payload) {
            commit("config/SET_OVERLAY", true, { root: true });
            try {
                const res = await axios.post('/api/orders/from-cart', payload);
                commit("setOrder", res.data);
                return res;
            } catch (error) {
                throw error;
            } finally {
                commit("config/SET_OVERLAY", false, { root: true });
            }
        },
        async showOrder({ commit }, id) {
            commit("config/SET_OVERLAY", true, { root: true });
            try {
                const res = await axios.get(`/api/orders/${id}`);
                commit("setOrder", res.data);
                return res.data;
            } catch (error) {
                throw error;
            } finally {
                commit("config/SET_OVERLAY", false, { root: true });
            }
        },
        async deleteOrder({ commit }, id) {
            commit("config/SET_OVERLAY", true, { root: true });
            try {
                const res = await axios.delete(`/api/orders/${id}`);
                return res.data;
            } catch (error) {
                throw error;
            } finally {
                commit("config/SET_OVERLAY", false, { root: true });
            }
        },
        async payPaypal({ commit }, id) {
            commit("config/SET_OVERLAY", true, { root: true });
            try {
                const res = await axios.post(`/api/create-payments/paypal/order/${id}`);
                console.log(res)
                return res;
            } catch (error) {
                throw error;
            } finally {
                commit("config/SET_OVERLAY", false, { root: true });
            }
        },
        async captureOrder({ commit }, token) {
            commit("config/SET_OVERLAY", true, { root: true });
            try {
                const res = await axios.post('/paypal/orders/capture', token);
                console.log(res)
                return res;
            } catch (error) {
                throw error;
            } finally {
                commit("config/SET_OVERLAY", false, { root: true });
            }
        },
    }
};
